<form [formGroup]="editCardForm" class="edit-wallet-form-container" (ngSubmit)="onEditCardFormSubmit()" *transloco="let t;">
    <div class="header-wrapper">
        <span class="form-title">{{t('modals.edit_wallet_modal.edit_title', {title: editTitle()})}}</span>
        <button class="button-undecorated" type="button" style="border-radius: 100%;" [attr.aria-label]="'Close Order Details Modal'"
            (click)="closeModal($event)">
            <cwo-round-icon [iconName]="iconNameType.close" [size]="'medium'" />
        </button>
    </div>

    <div class="errors-container">
        @if(allErrors?.length){
        <div class="generic-errors">
            @for (error of allErrors; track $index) {
            <div class="error-wrapper">
                <div class="icon-wrapper">
                    <cwo-icon class="icon" [name]="iconNameType.error"></cwo-icon>
                </div>
                <span class="error">{{error}}.</span>
            </div>
            }
        </div>
        }
    </div>

    <div class="input-group">
        @if (isCreditCard()) {
        <div class="expiration-zip-group">
            <div class="input-wrapper expiration-input">
                <cwo-mask-field-input formControlName="expiration" [maskPattern]="maskFieldInputType.shortDate"
                    [label]="'Exp. Date'" [invalid]="showErrors && editCardForm.controls['expiration'].invalid" />
                <div class="errors-wrapper">
                    @if(showErrors && editCardForm.controls['expiration'].invalid &&
                    editCardForm.controls['expiration'].hasError('required')){
                    <span class="input-error">
                        <cwo-icon class="icon" [name]="iconNameType.error"></cwo-icon>
                        {{validationMessages.expiration.required}}
                    </span>
                    }
                </div>
            </div>
            <div class="input-wrapper zip-input">
                <cwo-input formControlName="webBillingZip" [type]="'number'" [placeholder]="'Billing Zip'"
                    [required]="true" [invalid]="showErrors && editCardForm.controls['webBillingZip'].invalid" />
                <div class="errors-wrapper">
                    @if(showErrors && editCardForm.controls['webBillingZip'].invalid &&
                    editCardForm.controls['webBillingZip'].hasError('required')){
                    <span class="input-error">
                        <cwo-icon class="icon" [name]="iconNameType.error"></cwo-icon>
                        {{validationMessages.webBillingZip.required}}
                    </span>
                    }
                </div>
            </div>
        </div>

        <cwo-input formControlName="name" [type]="'text'" [placeholder]="'Name on Card (Optional)'" />
        }

        @else {
        <div class="input-wrapper">
            <cwo-input formControlName="friendlyName" [type]="'text'" [placeholder]="'Friendly Name'" [required]="true"
                [invalid]="showErrors && editCardForm.controls['friendlyName'].invalid" />
            <div class="errors-wrapper">
                @if(showErrors && editCardForm.controls['friendlyName'].invalid &&
                editCardForm.controls['friendlyName'].hasError('required')){
                <span class="input-error">
                    <cwo-icon class="icon" [name]="iconNameType.error"></cwo-icon>
                    {{validationMessages.friendlyName.required}}
                </span>
                }
            </div>
        </div>
        }
    </div>

    <div class="button-container">
        <button type="submit" class="button-accent submit-button">
            {{t('modals.edit_wallet_modal.done')}}
        </button>
    </div>
</form>